import declare from "dojo/_base/declare";
import TimeDateTime from "csi/heading/TimeDateTime";
import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import html from "csi/html";

const AdHocTimeRenderer = declare(TimeDateTime, {
	/**
	 * @override
	 * Hash out cell if not an ad-hoc request
	 */
	_getRenderCSS(ctx: Context, h: Heading, refNode: HTMLElement): string {
		return ctx.getNode().ClientStartRendering ? this.inherited<string>(arguments) : html.CSS_NOT_APPLICABLE;
	},
});

export = AdHocTimeRenderer;